import { DrawerWithNavigation } from '@npco/ui-drawer-navigation'
import { StyledContentContainer } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledDrawerWithNavigation = styled(DrawerWithNavigation)`
  ${StyledContentContainer} {
    margin-bottom: 0;
  }
`
